import { StartFootCheck } from "@/features/foot-watch/components/StartFootCheck";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/foot-watch/$diaryId/_view/new")({
    component: () => (
        <section className="mx-auto max-w-md">
            <StartFootCheck />
        </section>
    ),
});
